/**
 * Toast copy policy — match fxbazzar_frontend intent: show real API lines, not generic txn boilerplate.
 * Used by common.slice + any thunk that dispatches success toasts.
 */

/**
 * True when this success string should not open a toast (generic / empty).
 * Errors are handled separately and are never passed here.
 */
export function shouldSuppressGenericSuccessToast(text) {
  let raw = text != null ? String(text) : "";
  raw = raw.replace(/\u00a0/g, " ").replace(/\s+/g, " ").trim();
  if (!raw) return true;

  const lower = raw.toLowerCase();

  // Domain-specific lines are almost always meaningful
  const looksSpecific =
    /bank|account|beneficiary|ifsc|upi|pay-?in|pay-?out|withdraw|deposit|ledger|balance|position|order|watch|symbol|segment|valan|script|close|rollover|export|csv|clipboard|saved|updated|deleted|added|removed|submitted|request|record|qty|lot|price|limit|market/i.test(
      raw
    );
  if (looksSpecific) return false;

  if (
    /successful\s*transaction|transaction\s*(was\s*)?(successful|completed|complete)|transaction\s*success|success\w*\s+transact|transact\w*\s+(success|successful|completed|ok)/.test(
      lower
    )
  ) {
    return true;
  }
  if (/^success(ful)?\.?$/i.test(raw)) return true;
  if (/^ok\.?$/i.test(raw)) return true;
  if (/^done\.?$/i.test(raw)) return true;
  if (/operation\s*(completed|successful)/.test(lower)) return true;
  if (/request\s*(processed|completed|successful)/.test(lower)) return true;

  // Common gateway / ledger boilerplate: "transaction" + positive wording, no failure cues
  if (
    /\btransaction\b/.test(lower) &&
    /success|successful|completed|complete/.test(lower) &&
    !/fail|error|invalid|denied|reject|unable|cannot|could\s+not|not\s+be|not\s+complete|warning|declined|expired/i.test(
      lower
    )
  ) {
    return true;
  }

  return false;
}

/**
 * Prefer a concrete API message; if it is empty or generic, use contextual fallback (old UI pattern).
 * Returns null when nothing should be shown.
 */
export function resolveSuccessWithFallback(apiMessage, fallback) {
  const api = apiMessage != null ? String(apiMessage).trim() : "";
  if (api && !shouldSuppressGenericSuccessToast(api)) return api;
  const fb = fallback != null ? String(fallback).trim() : "";
  return fb || null;
}
